import { Injectable } from '@angular/core';
import { DataListModel } from '../../models/data-list-model';
import { Observable } from 'rxjs';
import { Product } from '../../dto/product';
import {HttpParams, HttpClient, HttpResponse} from '@angular/common/http';
import { CrudService } from '../../services';
import {Card} from '../../dto/card';
import {RiskAssementInquiry} from '../../dto/risk-assement-inquiry';
import {toServerDateString} from '../../providers/app-date-adapter';

@Injectable({
  providedIn: 'root'
})
export class RiskService {
  readonly apiPath = 'risk/';
  public id: number;
  constructor(
    private http: HttpClient,
  ) { }

  getStats(): Observable<any> {
    return this.http.get(this.apiPath + 'stats') as Observable<object>;
  }

  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
  ): Observable<DataListModel<RiskAssementInquiry>> {
    const params = new HttpParams()
      .set( 'page', pageIndex.toString() )
      .set( 'pageSize', pageSize.toString() )
      .set( 'filterString', filterString )
      .set( 'sortField', sortField )
      .set( 'sortDirection', sortDirection );
    return this.http.get( this.apiPath, { params } ) as Observable<DataListModel<RiskAssementInquiry>>;
  }

  get( id: number ): Observable<RiskAssementInquiry> {
    return this.http.get( this.apiPath + id ) as Observable<RiskAssementInquiry>;
  }

  getActiveInquiries(): Observable<number> {
    return this.http.get( this.apiPath + 'active-inquiries', {headers:{'skip-error-snack':'true'} } ) as Observable<number>;
  }

  add( item: RiskAssementInquiry ): Observable<RiskAssementInquiry> {
    return this.http.post( this.apiPath, item ) as Observable<RiskAssementInquiry>;
  }

  update( item: RiskAssementInquiry ) {
    return this.http.put( this.apiPath, item ) as Observable<RiskAssementInquiry>;
  }

  delete( id: any ) {
    return this.deleteMany( [ id ] );
  }

  restore( id: any ) {
    return this.restoreMany( [ id ] );
  }

  deleteMany( idList: any[] ) {
    let httpParams = new HttpParams();

    idList.forEach( id => {
      httpParams = httpParams.append( 'list', id.toString() );
    } );

    return this.http.delete( this.apiPath, { params: httpParams } );
  }

  restoreMany( idList: any[] ) {
    let httpParams = new HttpParams();
    idList.forEach( id => {
      httpParams = httpParams.append( 'list', id.toString() );
    } );
    return this.http.patch( this.apiPath, null, { params: httpParams } );
  }

  getActiveInquiryForCustomer( customerId: number ): Observable<RiskAssementInquiry> {
    return this.http.get( this.apiPath + 'customer/active-inquiry/' + customerId ) as Observable<RiskAssementInquiry>;
  }


  getBlockedCards(

    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string,
    additionalFilterData: string[],
    enumFilter: { key: string; value: string },
    companiesFilter: string[],


    ) {
    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString)
      .set('sortField', sortField)
      .set('sortDirection', sortDirection)
      .set('startFilterDate', toServerDateString(startFilterDate))
      .set('endFilterDate', toServerDateString(endFilterDate))
      .set('someAdditionalData', someAdditionalData);

    if (companiesFilter instanceof Array) {
      companiesFilter.forEach(element => {
        params = params.append('companiesFilter', element);
      });
    }

    return this.http.get(this.apiPath + 'blocked-cards', { params }) as Observable<DataListModel<Card>>;
  }

  getDormantCards(

    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string) {
    const params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString)
      .set('sortField', sortField)
      .set('sortDirection', sortDirection)
      .set('someAdditionalData', someAdditionalData);
    return this.http.get(this.apiPath + 'dormant-cards', { params }) as Observable<DataListModel<Card>>;
  }

}

export class RiskServiceBlockedCardsContainer implements CrudService<Card> {

  constructor(private riskService: RiskService) {

  }

  get(id: any): Observable<Card> {
        throw new Error('Method not implemented.');
  }
  add(item: Card): Observable<Object> {
      throw new Error('Method not implemented.');
  }
  update(id: any, item: Card): Observable<Object> {
      throw new Error('Method not implemented.');
  }
  delete(id: any): Observable<Object> {
      throw new Error('Method not implemented.');
  }
  restore(id: any): Observable<Object> {
      throw new Error('Method not implemented.');
  }
  deleteMany(list: any[]): Observable<Object> {
      throw new Error('Method not implemented.');
  }
  restoreMany(list: any[]): Observable<Object> {
      throw new Error('Method not implemented.');
  }

  getMany(pageIndex: number, pageSize: number, sortField: string, sortDirection: string, filterString: string, dateFilterCols: string[], startFilterDate: Date, endFilterDate: Date, someAdditionalData: string, additionalFilterData?: string[], enumFilter?: { key: string; value: string }, companiesFilter?: string[], additionalField1?: string, additionalField2?: string, additionalValue1?: string, additionalValue2?: string, identStatusFilter?: string[]): Observable<DataListModel<Card>> {


    return this.riskService.getBlockedCards(

      pageIndex,
      pageSize,
      sortField,
      sortDirection,
      filterString,
      startFilterDate,
      endFilterDate,
      someAdditionalData,
      additionalFilterData,
      enumFilter,
      companiesFilter,

    );
  }

}


export class RiskServiceDormantCardsContainer implements CrudService<Card> {

  constructor(private riskService: RiskService) {

  }

  getMany(pageIndex: number, pageSize: number, sortField: string, sortDirection: string, filterString: string, dateFilterCols: string[], startFilterDate: Date, endFilterDate: Date, someAdditionalData: string, additionalFilterData?: string[], enumFilter?: { key: string; value: string }, companiesFilter?: string[], additionalField1?: string, additionalField2?: string, additionalValue1?: string, additionalValue2?: string, identStatusFilter?: string[]): Observable<DataListModel<Card>> {

    return this.riskService.getDormantCards(

      pageIndex,
      pageSize,
      sortField,
      sortDirection,
      filterString,
      startFilterDate,
      endFilterDate,
      someAdditionalData

    );
  }

  get(id: any): Observable<Card> {
    throw new Error('Method not implemented.');
  }
  add(item: Card): Observable<Object> {
    throw new Error('Method not implemented.');
  }
  update(id: any, item: Card): Observable<Object> {
    throw new Error('Method not implemented.');
  }
  delete(id: any): Observable<Object> {
    throw new Error('Method not implemented.');
  }
  restore(id: any): Observable<Object> {
    throw new Error('Method not implemented.');
  }
  deleteMany(list: any[]): Observable<Object> {
    throw new Error('Method not implemented.');
  }
  restoreMany(list: any[]): Observable<Object> {
    throw new Error('Method not implemented.');
  }

}
